<small class="mr-2 text-muted">{{ config().bot.rateChat }}</small>
<button
    class="p-0"
    (focus)="handleIconHover(0)"
    (mouseover)="handleIconHover(0)">
    &nbsp;
    <span class="sr-only">0</span>
</button>
@for (rate of [1, 2, 3, 4, 5]; track $index; let last = $last) {
    <button
        (click)="wasClicked = true; rateConversation(rate)"
        (focus)="handleIconHover(rate)"
        (mouseover)="handleIconHover(rate)"
        [class]="{
            'mr-1': !last,
        }"
        class="p-0">
        <big-icon
            class="fill-primary"
            [size]="'w-3'"
            [icon]="currentRating() >= rate ? iconStarFilled : iconStar" />
    </button>
}
